
import React, { useState } from "react"
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Stack,
  Typography,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import PrintIcon from "@mui/icons-material/Print"
import axios from "axios"
import { toast } from "react-toastify"
import ReportPDF from "../reports/testReport"

export default function HistoryPrintDialog({
  open,
  onClose,
  selectedSampleId,
  allReports,
}: {
  open: boolean
  onClose: () => void
  selectedSampleId?: string
  testId?: string[]
  allReports?: any
}) {
  const [options, setOptions] = React.useState({
    showTestHistory: true,
    historyCount: 0,
  })

  const [reportData, setReportData] = React.useState<any>(null)
  const [print, setPrint] = useState(false)
  const [payload, setPayload] = useState<any>({
    historyCount: options.historyCount,
    sampleCollectionId: selectedSampleId || "",
    performedTestIds: [],
  })
  const GeneratePDF = async (testId: string) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_LAB_URL}/patient-result/printTestResults`,
        {
          ...payload,
          performedTestIds: [testId],
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      )
      if (response.status === 201) {
        setReportData(response?.data?.data)
        setPrint(true)
        onClose()
      }
    } catch (error:any) {
      console.error("Error fetching patient types:", error)
      toast.error(error?.response.data.message || "Error fetching patient types")
    }
  }

  const formatCreatedAt = (createdAt: string) => {
  const today = new Date(); // Today's date (2025-09-24)
  const createdDate = new Date(createdAt); // Parse createdAt date

  // Check if createdAt is today
  const isToday =
    createdDate.getFullYear() === today.getFullYear() &&
    createdDate.getMonth() === today.getMonth() &&
    createdDate.getDate() === today.getDate();

  if (isToday) {
    return "today";
  } else {
    // Format date as YYYY-MM-DD (or your preferred format)
    return createdDate.toISOString().split("T")[0]; // e.g., "2025-09-24"
  }
};

  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
        <DialogTitle
          sx={{
            fontWeight: "bold",
            fontSize: "1rem",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 1.5,
            pb: 1, // reduced bottom padding to make room for patient details
          }}
        >
          History test result
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        {allReports && (
          <Box sx={{ px: 2, pb: 1, borderBottom: "1px solid #e0e0e0" }}>
            <Stack direction="row" spacing={3} sx={{ flexWrap: "wrap", gap: 1 }}>
              <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                <strong>MR No:</strong> {allReports.mrn || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                <strong>Patient Name:</strong> {allReports.patientName || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                <strong>Guardian Name:</strong> {allReports.guardiansName || "N/A"}
              </Typography>
              <Typography variant="body2" sx={{ fontSize: "0.85rem" }}>
                <strong>Gender:</strong> {allReports.gender || "N/A"}
              </Typography>
            </Stack>
          </Box>
        )}

        <DialogContent sx={{ p: 2 }}>
          <Box sx={{ mb: 2 }}>
            {allReports && allReports?.performedTests?.length > 0 ? (
              <Table
                size="small" // ✅ MUI dense mode
                sx={{
                  minWidth: 650,
                  Height: 40,
                  overflowY: "auto",
                  "& .MuiTableCell-root": {
                    padding: "2px 6px", // ✅ slimmer cell padding
                    fontSize: "0.8rem",
                  },
                }}
              >
                <TableHead sx={{ backgroundColor: "#1976d2", color: "white" }}>
                  <TableRow
                    sx={{
                      height: 20,
                    }}
                  >
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Sr. #</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Test Code</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}> Test Name</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>approved By</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Approval Status</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>created On</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold" }}>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody sx={{overflowY: "auto" }}>
                  {allReports?.performedTests?.map((test: any, i: number) => (
                    <TableRow
                      key={test.testCode}
                      sx={{
                        "&:hover": { backgroundColor: "#f5f5f5" },
                        height: 28, // ✅ force slim body row height
                      }}
                    >
                      <TableCell>{i + 1}</TableCell>
                      <TableCell>{test.testCode}</TableCell>
                      <TableCell>{test.testName}</TableCell>
                      <TableCell>{test.approvedBy}</TableCell>
                      <TableCell>{test.approvalStatus}</TableCell>
                      <TableCell>{formatCreatedAt(test.createdAt)}</TableCell>
                      <TableCell>
                        <PrintIcon
                          onClick={() => GeneratePDF(test._id)}
                          sx={{ color: "green", cursor: "pointer" }}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            ) : (
                <Typography sx={{ fontSize: "16px", fontWeight: "bold", alignItems: "center", color: "gray", display: "flex",justifyContent: "center",justifyItems: "center" }} variant="body2">No test history available.</Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
      {print && reportData && <ReportPDF print={print} data={reportData} onClose={() => setPrint(false)} />}
    </>
  )
}
